import { Card, Grid } from "@mui/material";
import Step from "./Step";
import React, { useEffect, useState } from "react";
import { useLanguage } from "contexts/language.context";

export default function Stepper({ steps, activeStep, changeActiveStep, mode }) {
  const [states, setStates] = useState([]);
  const { label } = useLanguage();

  useEffect(() => {
    if (mode == "create") {
      setStates(
        steps.map((step, index) => {
          if (index < activeStep) return label("complete-label");
          else if (activeStep == index) return label("current-label");
          else return label("not-started-label");
        }),
      );
    } else {
      setStates(
        steps.map((step, index) => {
          if (activeStep == index) return label("current-label");
          else return label("not-started-label");
        }),
      );
    }
  }, [steps, activeStep, mode]);

  return (
    <Card
      variant="outlined"
      sx={{
        borderRadius: "16px",
        overflow: "hidden",
      }}
    >
      <Grid container spacing={0} sx={{ width: "100%", height: "100%" }}>
        {steps.map((step, index) => (
          <React.Fragment key={step.label}>
            <Step
              step={step}
              end={index === steps.length - 1}
              start={index === 0}
              state={states[index]}
              mode={mode}
              index={index}
              changeActiveStep={changeActiveStep}
            />
          </React.Fragment>
        ))}
      </Grid>
    </Card>
  );
}
